<script setup lang="ts">
import type { QuoteData } from '~/utils/crystallize/pieces'

defineProps<{ data: QuoteData }>()
</script>

<template>
  <section v-if="blocksHaveContent(data.text)" class="w-full py-3xl bg-blurple-500 text-white">
    <ContentGrid>
      <CrystallizeQuote class="2xl:col-span-8 2xl:col-start-3" :data="data" />
    </ContentGrid>
  </section>
</template>
